/** Checks whether a given value is null or undefined.
 * @param value - The given value to test.
 */
export const isNil = <T>(value: T | null | undefined): value is null | undefined => {
  return value === null || value === undefined;
};

/** If this guard triggers a linting error, it's because the switch statement it's used in
 * must be exhaustive, so all switch cases must be handled.
 */
export const exhaustiveMatchingGuard = (_: never): never => {
  throw new Error("Should not have reached here.");
};

const parseLsJSON = (json: string | null) => {
  try {
    return JSON.parse(json || "{}");
  } catch (ex) {
    console.error(ex);
    return null;
  }
};

type WhitelabelConfig = {
  logoUrl?: string;
  logoWidth?: number;
  logoHeight?: number;
};
export const getWhitelabelConfig = (): WhitelabelConfig | null => {
  return parseLsJSON(localStorage.getItem("whitelabelConfig")) as WhitelabelConfig | null;
};

/** polyfill for Object.fromEntries -> takes an array of entries and puts it back into an object type -- opposite of Obejct.entries */
export const objectFromEntries = (entriesArr: [string | number | symbol, any][]): Record<string, unknown> =>
  entriesArr.reduce((acc, [key, val]) => {
    const nextAcc = { ...acc };
    nextAcc[key] = val;
    return nextAcc;
  }, {} as any);

export const mapEntries = <T extends object>(
  theObject: T,
  f: (value: [string, any], index: number, array: [string, any][]) => [string | number | symbol, any]
): T => {
  return objectFromEntries(Object.entries(theObject).map(f)) as T;
};
